<template>
  <div class="normApply">
    <div class="table">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px">
        <p class="tip" v-if="tableRelevant.tableDataSource.length&&!allDeviceType">
          <a-icon type="close-circle" :style="{ color: '#f00' }" />
          全设备覆盖
        </p>
        <a-button @click="add()" icon="plus" type="primary">添加常模</a-button>
      </div>
      <a-table
        :columns="columns"
        row-key="id"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <div slot="name" slot-scope="text">
          <a-tag v-if="text.isDefault" color="#87d068">默认</a-tag>
          {{ text.name }}
        </div>
        <div slot="device" slot-scope="text">
          {{
            equipmentList
              .filter((f) => (f.id | text.deviceType) === text.deviceType)
              .map((m) => m.name)
              .join(' ')
          }}
        </div>
        <div slot="regionName" slot-scope="text">
          <span>{{ text.regionName ? text.regionName : '--' }}</span>
        </div>
        <div slot="dbqy" slot-scope="text">
          {{ text.areaCharacteristicSize && text.areaCharacteristicDescriptions != '[]' ? getDbqy(text.areaCharacteristicDescriptions) : '--' }}
        </div>
        <a-switch
          slot="enabled"
          slot-scope="text"
          v-model="text.enabled"
          @change="changeEnabled(text)"
          :disabled="text.isDefault"
          :loading="text.loading"
          checked-children="是"
          un-checked-children="否"
        />
        <div class="operate" slot="action" slot-scope="text">
          <a-button type="link" :disabled="!text.enabled" @click="view(text)">查看</a-button>
          <a-button type="link" @click="edit(text)">编辑</a-button>

          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-button :disabled="!text.enabled" @click="exportView(text)" type="link">导出</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button @click="normRecord(text)" type="link">记录</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button :disabled="text.isDefault" @click="listDeleteItem(text)" type="link" danger>删除</a-button>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-table>
    </div>
    <!-- 添加常模 -->
    <a-modal :centered="true" v-model="addNorm.visible" :title="addNorm.title" :confirm-loading="addNorm.confirmLoading" @ok="addNormOk" @cancel="addNormCancel" width="600px">
      <a-form-model ref="addNormForm" :labelCol="{ span: 6 }" :wrapperCol="{ span: 17 }" :model="addNorm.data" :rules="addNorm.rules">
        <a-form-model-item label="游戏名称" prop="contentName">
          <a-input v-model="addNorm.data.contentName" disabled :maxLength="25" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="常模名称" prop="name">
          <a-input v-model.trim="addNorm.data.name" allowClear :maxLength="15" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="应用设备" prop="deviceType">
          <a-select mode="multiple" allowClear v-model="addNorm.data.deviceType" placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in equipmentList" :key="item.id" :disabled="isDeviceTypeDisabled(item)">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="应用区域" prop="address">
          <a-cascader v-model="addNorm.data.address" :options="addressOptions" :load-data="addressLoadData" placeholder="请选择应用区域" change-on-select allowClear />
        </a-form-model-item>
        <!-- <a-form-model-item label="应用人群" prop="normTag">
          <a-select placeholder="请选择" v-model="addNorm.data.normTag">
            <a-select-option v-for="item in addNorm.normTags" :value="item">{{ item }}</a-select-option>
            <span slot="suffixIcon" class="custom-label" @click.stop="changeCustom"><a-icon type="plus" style="font-size: 10px;margin-right: 2px;" />自定义</span>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item label="是否生效" prop="enabled">
          <a-radio-group v-model="addNorm.data.enabled">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="是否默认常模" prop="isDefault">
          <a-radio-group :disabled="!tableRelevant.tableDataSource.length" v-model="addNorm.data.isDefault">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div>
          <div class="um-download">
            <h4 class="um-h4">模板下载</h4>
            <p align="center">
              <a @click="downloadTemplate" class="templateDownload">模板下载</a>
            </p>
          </div>
          <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" @change="unploadChange">
            <h4 class="um-upload">上传文件</h4>
            <p class="ant-upload-drag-icon">
              <a-icon type="cloud-upload" />
            </p>
            <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
            <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
          </a-upload-dragger>
          <a @click="down()" v-if="errorData.length" style="text-align: center; margin: 20px 0; display: block; color: #f00">点击这里下载错误数据</a>
        </div>
      </a-form-model>
    </a-modal>
    <select-course v-model="selectCourse.visible" :courses="addNorm.data.course" @ok="confirmSelectCourse" />
    <view-records ref="viewRecordsRef"></view-records>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import xlsx from 'xlsx-js-style'
import SelectCourse from './SelectCourse.vue'
import ViewRecords from './ViewRecords.vue'
import { ParamsApi } from '@/utils/http'

const columns = [
  { title: '常模名称', scopedSlots: { customRender: 'name' } },
  { title: '应用设备', scopedSlots: { customRender: 'device' } },
  { title: '应用区域', scopedSlots: { customRender: 'regionName' } },
  { title: '是否生效', scopedSlots: { customRender: 'enabled' } },
  { title: '样本量', dataIndex: 'sampleSize' },
  { title: '代表区域', scopedSlots: { customRender: 'dbqy' } },
  { title: '更新时间', dataIndex: 'updateTime', align: 'center' },
  { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center' },
]
const recordColumns = [
  { title: '样本量', scopedSlots: { customRender: 'sampleSize' }, align: 'center' },
  { title: '是否生效', scopedSlots: { customRender: 'status' }, align: 'center' },
  { title: '创建时间', dataIndex: 'createTime', align: 'center' },
  { title: '备注', scopedSlots: { customRender: 'desc' }, width: 150 },
  { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 155 },
]
const contrastColumns = [
  { title: '年龄', dataIndex: 'age', align: 'center' },
  { title: '性别', dataIndex: 'genderName', align: 'center' },
  { title: '样本量', dataIndex: 'existsSampleCount', align: 'center' },
  { title: '平均分', dataIndex: 'existsSampleAvgScore', align: 'center' },
  { title: '标准差', dataIndex: 'existsSampleStd', align: 'center' },
]
export default {
  name: 'NormApply',
  components: { SelectCourse, ViewRecords },
  data() {
    return {
      abilityInfo: this.$store.getters['content/getAbilityInfo'](),
      contrastColumns,
      columns,
      tableRelevant: tableRelevant.call(this, this.getList),
      searchForm: {
        useOrCalculate: 1, //0 计算；1 应用
        deviceType: [],
        ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
      },
      equipmentList: [
        { id: 1, name: '其他' },
        { id: 2, name: '键盘' },
        { id: 4, name: '鼠标' },
        { id: 8, name: '触摸屏' },
        { id: 16, name: '全部' },
      ],
      addressOptions: [],
      addNorm: {
        visible: false,
        title: '添加常模',
        confirmLoading: false,
        showSearch: false,
        data: {
          name: '',
          address: [0],
          contentName: sessionStorage.getItem('currentName'),
          deviceType: [16],
          enabled: true,
          isDefault: true,
        },
        rules: {
          address: [{ required: true, message: '请选择应用区域', trigger: 'change' }],
          contentName: [{ required: true, message: '请输入游戏名称', trigger: 'blur' }],
          name: [{ required: true, message: '请输入常模名称', trigger: 'blur' }],
          deviceType: [{ required: true, message: '请选择应用设备', trigger: 'change' }],
          normTag: [{ required: true, message: '请选择应用人群', trigger: 'change' }],
          enabled: [{ required: true, message: '请选择是否生效', trigger: 'blur' }],
          isDefault: [{ required: true, message: '请选择是否默认常模', trigger: 'blur' }],
        },
      },

      baseURL: process.env.VUE_APP_API_BASE_URL,
      errorData: [],
      fileList: [],
      file: '',

      normRecordDeviceType: '',
      recordColumns,
      record: {
        visible: false,
        title: '常模记录',
        confirmLoading: false,
        tableRelevant: tableRelevant.call(this, this.getList),
      },
      allDeviceType: false,
      normRecordText: {},
      excelTitle: '',

      selectCourse: {
        visible: false,
      },
    }
  },
  computed: {
    getDbqy() {
      return function (areaCharacteristicDescriptions) {
        try {
          const area = JSON.parse(areaCharacteristicDescriptions)
          return area
            .map((item) => {
              if (typeof item === 'string') {
                return item
              } else {
                return item.label
              }
            })
            .join(',')
        } catch (error) {
          return '--'
        }
      }
    },
    addCourseName() {
      if (this.addNorm.data.course.length) {
        return this.addNorm.data.course.map((v) => v.name).join('，')
      }
      return '全部'
    },
  },
  watch: {
    'addNorm.visible'(val) {
      if (!val) {
        this.addNormCancel()
      }
    },
  },
  mounted() {
    // this.$store.commit("content/setNormInfo",  "");
    let name = sessionStorage.getItem('currentName')
    let version = this.$route.query.version
    if (version) {
      this.excelTitle = name + '(' + version + ')' + ' 常模配置'
    } else {
      this.excelTitle = name + ' 常模配置'
    }
    this.getList(1)
  },
  methods: {
    async saveLabelNorm(value) {
      const params = {
        key: 'NormTag',
        valueType: 2,
        remark: '',
        ...(this.normTagData || {}),
        value,
      }
      await ParamsApi.editRecord(params)
    },
    isDeviceTypeDisabled(item) {
      const deviceType = this.addNorm.data.deviceType.reduce((deviceType, v) => deviceType | v, 0)
      if (deviceType == 0) return false
      if (deviceType & 16 && item.id != 16) {
        return true
      }
      if (!(deviceType & 16) && item.id == 16) {
        return true
      }
      return false
    },
    changeCustom() {
      let inputValue = ''
      this.$confirm({
        icon: () => '',
        title: '自定义标签',
        content: (h) =>
          h('a-input', {
            props: {
              maxLength: 10,
              placeholder: '请输入内容',
            },
            on: {
              change: (e) => {
                inputValue = e.target.value
              },
            },
          }),
        onOk: () => {
          this.addNorm.normTags.push(inputValue)
          this.addNorm.data.normTag = inputValue
          this.saveLabelNorm(JSON.stringify(this.addNorm.normTags))
        },
      })
    },
    confirmSelectCourse(courses) {
      this.addNorm.data.course = courses
    },
    openSelectCourse() {
      this.selectCourse.visible = true
    },
    /**
     * 获取地址
     * @param id 查询的省市区
     */
    getAddressList(id) {
      return new Promise((resolve, reject) => {
        this.$http.Mechanism.address({ parentId: id || 0 }).then((res) => {
          const { data } = res
          if (id) {
            resolve(
              data.map((v) => {
                return {
                  id: v.id,
                  value: v.id,
                  label: v.name,
                  isLeaf: v.level === 4,
                  loading: false,
                }
              })
            )
          } else {
            let str = {
              id: 0,
              name: '全国',
              isLeaf: true,
              loading: false,
            }
            data.unshift(str)
            this.addressOptions = data.map((v) => {
              return {
                id: v.id,
                value: v.id,
                label: v.name,
                isLeaf: v.id === 0,
                loading: false,
              }
            })
          }
        })
      })
    },
    addressLoadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      return this.getAddressList(targetOption.value).then((data) => {
        targetOption.loading = false
        targetOption.children = data
        this.addressOptions = [...this.addressOptions]
        return data
      })
    },
    // 批量导入模板下载
    downloadTemplate() {
      const xhr = new XMLHttpRequest()
      let TemplateUrl = process.env.VUE_APP_TEMPLATE_URL + '/template/excel/Import_Norm_Template.xlsx'
      console.log(TemplateUrl)
      xhr.open('GET', TemplateUrl, true)
      xhr.responseType = 'blob'
      xhr.send()
      xhr.onload = function () {
        if (xhr.status === 200) {
          const a = document.createElement('a')
          a.href = window.URL.createObjectURL(xhr.response)
          a.download = '添加常模模板.xlsx'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      }
    },
    getList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.allDeviceType = false
      let allDeviceCount = 0
      this.$http.NormSet.getList(params)
        .then((res) => {
          this.tableRelevant.tableDataSource = res.data.items.map(m => {
            if (m.enabled) {
              if (m.deviceType & 16) {
                this.allDeviceType = true
              }
              allDeviceCount |= m.deviceType
            }
            return m;
          })
          this.tableRelevant.tablePagination.total = res.data.totalCount
          this.tableRelevant.tablePagination.current = res.data.pageIndex

          if(!this.allDeviceType){
            this.allDeviceType = allDeviceCount==15
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addNormCancel() {
      this.file = ''
      this.fileList = []
      this.errorData = []
      this.addNorm.visible = false
      this.addNorm.data = {
        name: '',
        address: [0],
        contentName: sessionStorage.getItem('currentName'),
        deviceType: [16],
        enabled: true,
        isDefault: true,
        course: [],
      }
      this.$refs.addNormForm.resetFields()
    },
    async getModeNorms() {
      const {data} = await this.$http.Base.getModelByKey({ key: 'NormTag' })
      this.normTagData = data
      if (data.enabled) {
        this.addNorm.normTags = JSON.parse(data.value)
      }
    },
    // 添加常模
    add() {
      this.getAddressList()
      // this.getModeNorms()
      this.addNorm.title = '添加常模'
      this.addNorm.visible = true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      this.errorFile = false
      const bool = this.fileList.filter((v) => v.name === file.name).length
      if (bool) {
        this.$message.warning('已有相同的文件，请重新选择文件')
        return false
      }
      let fileType = file.name.substring(file.name.lastIndexOf('.'))
      if (fileType != '.xlsx' && fileType != '.xls') {
        this.$message.warning('文件格式不支持')
        return false
      }
      this.fileList = [file]
      return false
    },
    unploadChange(value) {
      if (value.fileList.length) {
        this.file = value.file
      } else {
        this.file = ''
      }
    },
    // 保存添加常模
    addNormOk() {
      this.$refs.addNormForm.validate((valid) => {
        if (valid) {
          if (this.file) {
            let formData = new FormData()
            formData.append('regionId', this.addNorm.data.address[this.addNorm.data.address.length - 1])
            formData.append('excelfile', this.file)
            formData.append('ContentAlgorithmCodeConfigId', this.$route.query.ContentAlgorithmCodeConfigId)
            formData.append('ContentAbilityId', this.abilityInfo.id)
            formData.append(
              'DeviceType',
              this.addNorm.data.deviceType.reduce((a, b) => a + b, 0)
            )
            formData.append('Enabled', this.addNorm.data.enabled)
            formData.append('normTag', this.addNorm.data.normTag)
            formData.append('name', this.addNorm.data.name)
            formData.append('isDefault', this.addNorm.data.isDefault)
            this.upload(formData)
          } else {
            this.$message.destroy()
            this.$message.warning('请选择xlsx文件')
          }
        } else {
        }
      })
    },
    upload(formData) {
      this.addNorm.confirmLoading = true;
      this.$http.NormSet.NormUpload(formData).then((res) => {
        this.$message.success(res.message);
        this.file = "";
        this.fileList = [];
        this.getList(1);
        this.addNormCancel();
      }).catch(e => {
        if (Array.isArray(e.data) && e.data.length) {
          this.errorData = e.data;
          this.getList(1);
        }
      }).finally(() => {
        this.addNorm.confirmLoading = false;
      });
    },
    // 下载错误原因
    down() {
      const titleList = ["游戏名称", "版本名称", "年龄", "性别", "样本量", "平均分", "标准差", "错误信息"];
      const list = [titleList].concat(this.errorData.map(m => ([
        m.contentName,
        m.version,
        m.age,
        m.genderName,
        m.sampleSizeStr,
        m.avg,
        m.std,
        m.messageList.join("\n"),
      ])));

      // 创建一个新的工作簿
      const workbook = xlsx.utils.book_new();
      // 将数据转换为工作表
      const worksheet = xlsx.utils.aoa_to_sheet(list);
      // 设置列宽
      const cols = [];
      // 设置内容样式
      Object.keys(worksheet).forEach(f => {
        if (typeof worksheet[f] !== 'object') {
          return;
        }
        worksheet[f].s = {
          font: {
            sz: 12,
            color: { rgb: '000000' }
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          }
        };
      });
      // 设置表头样式
      titleList.forEach((f, i) => {
        const ex = xlsx.utils.encode_cell({ r: 0, c: i });
        worksheet[ex].s = {
          font: {
            sz: 12,
            bold: true,
            color: { rgb: worksheet[ex].v === '错误信息' ? 'FF0000' : '000000' }
          },
          fill: {
            fgColor: { rgb: 'eeeeeeff' } // 背景
          },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } }, // 上边框
            bottom: { style: 'thin', color: { rgb: '000000' } }, // 下边框
            left: { style: 'thin', color: { rgb: '000000' } }, // 左边框
            right: { style: 'thin', color: { rgb: '000000' } } // 右边框
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          }
        };
        // 设置列宽
        cols.push({ wpx: worksheet[ex].v === '错误信息' ? 250 : 120 });
      })
      // 设置列宽
      worksheet['!cols'] = cols;
      // 设置行高
      worksheet['!rows'] = list.map(m => ({ hpt: 23 }));
      // 将工作表添加到工作簿中
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      // 将工作簿导出为 Excel 文件
      xlsx.writeFile(workbook, '常模配置错误数据.xlsx');
    },
    // 记录
    async normRecord(text) {
      await this.$refs['viewRecordsRef'].showModal({ normId: text.id, normName: text.name, excelTitle: this.excelTitle })
    },
    // 修改状态
    changeEnabled(text) {
      let formData = new FormData()
      formData.append('id', text.id)
      formData.append('enabled', text.enabled)
      text.loading = true
      this.$http.NormSet.NormIsEnabled(formData)
        .then((res) => {
          this.$message.success(res.message)
          // this.normRecord(this.normRecordText);
          this.getList(1)
        })
        .finally(() => {
          text.loading = false
        })
    },
    // 查看
    view(text) {
      this.$store.commit('content/setNormInfo', { ...text, fullPath: this.$route.fullPath })
      this.$router.push({
        path: '/content/NormSeting/NormComputeDetail',
        query: {
          id: this.abilityInfo.id,
          type: this.$route.query.type,
          version: this.$route.query.version,
          ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
          recordId: text.id,
          pegetype: 'apply',
          sampleSize: text.sampleSize,
          contentId: this.$route.query.contentId,
        },
      })
    },
    // 编辑
    edit(text) {
      this.$store.commit('content/setNormInfo', { ...text, fullPath: this.$route.fullPath })
      this.$router.push({
        path: '/content/NormSeting/NormComputeSet',
        query: {
          id: this.abilityInfo.id,
          type: this.$route.query.type,
          version: this.$route.query.version,
          ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
          recordId: text.id,
          sampleSize: text.sampleSize,
          abilityId: this.$route.query.abilityId,
          contentId: this.$route.query.contentId,
        },
      })
    },
    // 列表删除
    listDeleteItem(text) {
      this.$confirm({
        title: '确定删除常模?',
        okType: 'danger',
        centered: true,
        onOk: () => {
          let formData = new FormData()
          formData.append('Id', text.id)
          formData.append('Deleted', true)
          this.$http.Content.normDelete(formData).then((res) => {
            this.$message.success(res.message)
            this.getList(1)
          })
        },
      })
    },
    // 删除
    deleteitem(text) {
      let formData = new FormData()
      formData.append('id', text.id)
      formData.append('deleted', true)
      this.$http.NormSet.NormDelete(formData)
        .then((res) => {
          const { message } = res
          this.$message.success(message)
          this.getList(1)
          this.normRecord(this.normRecordText)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 导出
    exportView(text) {
      let params = {
        id: text.id,
      }
      this.$http.NormSet.getDetail(params)
        .then((res) => {
          const { data } = res
          const arr = [contrastColumns.map((m) => m.title)]
          arr[0].unshift('版本名称')
          arr[0].unshift('游戏名称')
          data.norms.forEach((f) => {
            arr.push([
              sessionStorage.getItem('currentName'),
              this.$route.query.version,
              f.age,
              f.gender == 0 ? 'all' : f.gender == 1 ? 'male' : 'female',
              f.sampleCount,
              f.average,
              f.standardDeviation,
            ])
          })
          const aoa = xlsx.utils.aoa_to_sheet(arr)
          const book = xlsx.utils.book_new()
          xlsx.utils.book_append_sheet(book, aoa, '第一页')
          xlsx.writeFile(book, this.excelTitle + '.xlsx')
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style scoped lang="less">
.search {
  margin-top: 15px;
}

.table {
  position: relative;
}

.tip {
  padding: 15px 0;
  margin: 0;
}

.um-download {
  border-top: 2px solid #eee;
  height: 60px;
  position: relative;
  margin-top: 30px;

  .um-h4 {
    padding: 0 10px;
    position: absolute;
    left: 20px;
    top: -15px;
    background-color: #fff;
    font-size: 16px;
  }

  p {
    line-height: 60px;
  }
}

.um-upload {
  font-size: 16px;
  position: absolute;
  left: 30px;
  top: 5px;
}

.um-form {
  padding: 0 24px;
}

.table-desc {
  min-height: 21px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  position: relative;
}

.table-desc:hover .anticon {
  display: inline;
}

.table-desc .anticon {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 2px 5px;
  background: #fff;
  cursor: pointer;
  display: none;
}

.table-textarea {
  width: 250px;
  height: 100px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
  overflow-y: auto;
}
.custom-label {
  color: var(--color);
}
</style>
